import React, { useEffect, useState } from "react";
import logo from "../assets/img/logo2.svg";
import { fetchXp, fetchLevel } from "apiHandles/user_progress";
import "../assets/css/Home.css";
import "../assets/css/argon-dashboard-react.css";
import CommonHeader from "./CommonHeader";
import { useDarkMode } from "context/DarkModeProvider";
import "../assets/css/colors.css"

const HomePage = ({ children }) => {

  const [xp, setXp] = React.useState(0);
  const [level, setLevel] = React.useState(null);
  var fetcheds = false;

  React.useEffect(() => {
    const getXp = async () => {
      const xp = await fetchXp();
      setXp(xp || 0);
    };
    getXp();
  }, []);

  React.useEffect(() => {
    const getLevel = async () => {
      const level = await fetchLevel();
      setLevel(level);
      fetcheds = true;
    };
    getLevel();
  }, []);

  const { darkMode } = useDarkMode();

  return (
    <div
      className="homePage-background"
      style={{
        background: darkMode
          ? '#0f172a'
          : 'var(--lightModeBack)',
        minHeight: '100vh',
        transition: 'background 0.3s ease'
      }}
    >
      <CommonHeader />
      <main
        className="dasa-background"
      >
        {children}
      </main>
    </div >
  );
};

export default HomePage;